// APP CONFIG
export const $themeConfig = {
    lang: 'pt', // en, da, de, el, es, fr, hu, it, ja, pl, pt, ru, sv, tr, zh
    theme: 'dark', // light, dark, system
    navigation: 'vertical', // vertical, collapsible-vertical, horizontal
    layout: 'full', // full, boxed-layout, large-boxed-layout
};
